module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"missing_required_fields":"Condition not met; reward unavailable."}}')
  delete Component.options._Ctor
}
